<template>
	<SOSlotBase
		:bg-white="true"
		:loading="isFetching"
	>
		<template v-slot:loading-page>
			<SOLoadingPage/>
		</template>

		<template v-slot:title-bar>
			<SOTitleBar
				:page-title="'Pilih Konsumen'"
				:type="'back'"
				@back="back"
			/>
		</template>

		<template v-slot:content>
			<div class="p-x-20 p-y-16">
				<div class="pilih-konsumen-box m-d-16">
					<div class="pilih-konsumen-box-filter-content p-x-8 p-y-12">
						<ul class="p-l-20 m-0 f-regular f-12 f-c-midgrey">
							<li v-if="getKey !== ''"><b>Pencarian:</b> {{ getKey }}</li>
							<li v-if="getFilterBy !== ''"><b>Filter konsumen berdasarkan:</b> {{ getFilterBy }}</li>
							<li v-if="getTahun !== ''"><b>Tahun:</b> {{ getTahun }}</li>
							<li v-if="getBulan !== ''"><b>Bulan:</b> {{ getBulan }}</li>
							<li v-if="getPeriode !== ''"><b>Periode:</b> {{ getPeriode }}</li>
							<li v-if="getFilterKolom"><b>Filter kolom:</b> {{ getFilterKolom }}</li>
							<li v-if="getFilterLayanan !== ''"><b>Filter layanan:</b> {{ getFilterLayanan }}</li>
							<li v-if="getJumlahLayanan > 0"><b>Jumlah layanan:</b> {{ getJumlahLayanan }} Layanan</li>
							<li v-if="getJumlahDeposit > 0"><b>Jumlah deposit:</b> {{ getJumlahDeposit }} Deposit</li>
							<li v-if="getJumlahOutlet > 0"><b>Jumlah outlet:</b> {{ getJumlahOutlet }} Outlet</li>
						</ul>
					</div>
					<div class="p-x-12 p-y-8 d-flex justify-content-center f-c-blue" @click="filter">
						Ubah kriteria
					</div>
				</div>

				<div class="f-regular f-14 f-c-midgrey m-d-16" v-if="totalCustomer > 0">
					<img src="@/assets/icons/arrow-down.svg" class="m-r-8" alt="">
					Ditemukan {{ totalCustomer }} Konsumen
				</div>

				<div class="pilih-konsumen-box" v-if="totalCustomer > 0">
					<div class="row m-0 border-bottom p-x-12 p-y-8 pilih-konsumen-table-head">
						<div class="col-6 p-0 f-bold f-14 f-c-midgrey">Nama</div>
						<div class="col-6 p-0 f-bold f-14 f-c-midgrey">Nomor</div>
					</div>
					<div class="row m-0 border-bottom p-x-12 p-y-8" v-for="customer, idx in listCustomer" :key="`customer-${idx}`">
						<div class="col-6 p-0 f-regular f-14 f-c-black">{{ customer.nama }}</div>
						<div class="col-6 p-0 f-regular f-14 f-c-midgrey">+{{ customer.telp !== "" ? customer.telp : "-" }}</div>
					</div>
                    <div class="row m-0 border-bottom p-x-12 p-y-8" v-if="totalCustomer > 20">
                        <div class="p-0 f-regular f-14 f-c-midgrey w-100 d-flex justify-content-center">
                            Dan {{ totalCustomer - 20 }} konsumen lainnya
                        </div>
                    </div>
				</div>

				<div class="pilih-konsumen-box bg-grey" v-if="totalCustomer === 0">
					<div class="text-center p-x-20 p-y-20">

						<img class="m-0" src="@/assets/icons/empty.svg" alt="">
						<div class="f-bold f-16 f-c-black">
							Konsumen dengan kriteria tersebut tidak ditemukan
						</div>
						<div class="f-regular f-14 f-c-midgrey">
							Silakan ubah kriteria filter
						</div>
					</div>
				</div>

                <div class="p-d-72"></div>
			</div>

			<div
				class="d-flex align-items-center btn_action_wrapper col-md-12 col-sm-12 col-12 p-0 bg-white shadow"
				style="position: fixed; bottom: 64px;">
				<div class="p-x-20 p-y-8 w-100">
					<div class="row m-0">
						<div class="col-6 p-0">
							<div class="f-regular f-12 f-c-midgrey">Terpilih total</div>
							<div class="f-regular f-14 f-c-black">
                                {{ totalCustomer }} Konsumen
							</div>
						</div>
						<div class="col-6 p-0">
							<button class="btn btn-primary btn-block m-0" @click="back">Pilih konsumen</button>
						</div>
					</div>
				</div>
			</div>
		</template>
	</SOSlotBase>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {moduleName} from "./../store/state";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

export default {
	name: "WABlastPilihKonsumen",
	components: {
		SOSlotBase,
		SOLoadingPage,
		SOTitleBar,
	},
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            listCustomer: "listCustomer",
            totalCustomer: "totalCustomer",
            payload: "payloadCreateBlast",
        }),
		...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem",
        }),

        getKey() {
            return this.payload.filter_customer.key
        },
        getFilterBy() {
            return this.payload.filter_customer.filter_by
        },
        getTahun() {
            if (!this.payload.filter_customer.filter_by === "tahun") {
                return ''
            }
            return this.payload.filter_customer.tahun
        },
        getBulan() {
            if (this.payload.filter_customer.filter_by !== "bulan") {
                return ''
            }
            return this.payload.filter_customer.bulan === '' ? '' : this.$moment(this.payload.filter_customer.bulan, "YYYY-MM").format("MMMM YYYY")
        },
        getPeriode() {
            if (this.payload.filter_customer.filter_by !== "periode") {
                return ''
            }
            return this.payload.filter_customer.tanggal_awal === '' && this.payload.filter_customer.tanggal_akhir === ''
                ? ''
                : `${this.$moment(this.payload.filter_customer.tanggal_awal).format("DD MMM YYYY")}` + " - "  +`${this.$moment(this.payload.filter_customer.tanggal_akhir).format("DD MMM YYYY")}`
        },
        getFilterKolom() {
            return this.payload.filter_customer.filter_kolom ? this.payload.filter_customer.filter_kolom.replace(/_/g, ' ') : ''
        },
        getFilterLayanan() {
            return this.payload.filter_customer.filter_layanan_by !== '' ? this.payload.filter_customer.filter_layanan_by.replace(/_/g, ' '): ''
        },
        getJumlahLayanan() {
            return this.payload.filter_customer.idlayanan_array.length
        },
        getJumlahDeposit() {
            return this.payload.filter_customer.iddeposit_array.length
        },
        getJumlahOutlet() {
            return this.payload.filter_customer.outlet_array.length
        }
    },
    mounted() {
        this.fetchListCustomer(this.payload.filter_customer)
    },
    methods: {
        ...mapActions({
            fetchListCustomer: `${moduleName}/fetchListCustomer`,
            // setPayloadCreateBlast: `${moduleName}/setPayloadCreateBlast`,
            setResponse: `${moduleName}/setResponse`,
            setFetching: `${moduleName}/setFetching`,
        }),
		back() {
            this.$router.back()
            setTimeout(() => {
                window.scrollTo(0,document.body.scrollHeight);
            }, 1000)
		},
		async filter() {
			let temp = {
                ...this.filterItem,
                filterRentangTanggalKonsumen: "periode_terdaftar",
            };

			await this.$store.commit("filterGlobalModule/setFilterItem", temp);

			this.$router.push({name: "wa_blast.pilih_konsumen.filter"})


		}
	}
}
</script>

<style scoped>
.pilih-konsumen-box {
	border-radius: 8px;
	border: 1px solid #C8D0DD;
}

.pilih-konsumen-box-filter-content {
	background: #F2F5F7;
	border-bottom: 1px solid #EDEDED;
}

.pilih-konsumen-table-head {
	background: #F2F5F7;
	border-top-right-radius: 8px;
	border-top-left-radius: 8px;
}
</style>